<template>
  <a-modal
    :open="Boolean(publishInfo?.id)"
    :footer="null"
    :width="648"
    closable
    :title="$t('fa-bu-shi-pin')"
    centered
    wrapClassName="xmov-form-modal yy-publish-modal"
    @cancel="onClose"
  >
    <a-spin :spinning="loading">
      <PublishForm
        :data="publishInfo"
        :bliarea="blibliArea"
        :platform="platformList"
        @logout="logout"
        @reload="fetchPlatform"
        @success="onClose"
        @cancel="onClose"
      />
    </a-spin>
  </a-modal>
</template>

<script lang="ts" setup>
import PublishForm from './form.vue'
import { PLATFORM_TYPE } from '@/constants/publish'
import { getPublishCode, getBliBliArea, delPublishAuth } from '@/api'
import { PUBLISH_PLATFORM, type UserPublishItem } from '~/api/interface/publish'

const platformList = ref<UserPublishItem[]>([])
const blibliArea: any = ref([])
const loading = ref(true)
const publishInfo: any = usePublishInfo()

onMounted(() => {
  fetchPlatform()
})

const onClose = () => {
  publishInfo.value = undefined
}

// 获取平台列表
const fetchPlatform = async () => {
  const { data } = await getPublishCode()

  loading.value = false
  platformList.value =
    data?.results
      ?.filter(
        (item: UserPublishItem) =>
          item.platform_type !== PUBLISH_PLATFORM.YOUTUBE
      )
      ?.map((item: UserPublishItem) => {
        return {
          ...item,
          ...PLATFORM_TYPE()[item.platform_type],
        }
      })
      .sort((a: any, b: any) => a.platform_type - b.platform_type) || []
  // B站需要获取分区
  const blibliInfo = data?.results.find(
    (o) => o.platform_type === PUBLISH_PLATFORM.BLIBLI
  )
  if (blibliInfo && !blibliInfo?.auth_url && !blibliArea.value.length) {
    fetchBliArea()
  }
}

// 获取B站分区
const fetchBliArea = async () => {
  const res = await getBliBliArea()

  if (!res.code && res.data) {
    blibliArea.value = res.data.area_info
  }
}

const { $t } = useNuxtApp()
// 退出授权
const logout = (platform_type: number) => {
  delPublishAuth({
    platform_type,
  }).then((res) => {
    if (res) {
      message.success($t('tui-chu-shou-quan-cheng-gong'))
      fetchPlatform()
    }
  })
}
</script>

<style lang="scss">
.yy-publish-modal {
  .ant-modal-header {
    .ant-modal-title {
      text-align: left;
    }
  }
  .ant-modal-body {
    padding: 0 !important;
    border-bottom: none !important;
  }
}
</style>
